export const ApplicationStatus = {
  All: "all",
  ["SDO Review"]: "sdo-review",
  ["Department Review"]: "dept-review",
  ["DMC Review"]: "dmc-review",
  Approved: "approved",
  Rejected: "rejected",
};

function createData(
  id,
  trackingId,
  submissionDate,
  purpose,
  status,
  lastUpdated
) {
  return {
    id,
    trackingId,
    submissionDate,
    purpose,
    status,
    lastUpdated,
  };
}

export const ApplicationTableRows = [
  createData(
    1,
    "NGP-25-1-11",
    "15/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Approved,
    "15/02/2025"
  ),
  createData(
    2,
    "NGP-25-1-1",
    "16/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["DMC Review"],
    "15/02/2025"
  ),
  createData(
    3,
    "FLP-2025-003",
    "17/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["Department Review"],
    "15/02/2025"
  ),
  createData(
    4,
    "FLP-2025-004",
    "18/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Rejected,
    "15/02/2025"
  ),
  createData(
    5,
    "FLP-2025-005",
    "19/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Approved,
    "15/02/2025"
  ),
  createData(
    6,
    "FLP-2025-006",
    "21/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["SDO Review"],
    "15/02/2025"
  ),
  createData(
    7,
    "FLP-2025-007",
    "22/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Rejected,
    "15/02/2025"
  ),
  createData(
    8,
    "FLP-2025-008",
    "23/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["DMC Review"],
    "15/02/2025"
  ),
  createData(
    9,
    "FLP-2025-009",
    "24/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Approved,
    "15/02/2025"
  ),
  createData(
    10,
    "FLP-2025-010",
    "25/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["Department Review"],
    "15/02/2025"
  ),
  createData(
    11,
    "FLP-2025-011",
    "26/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus["Department Review"],
    "15/02/2025"
  ),
  createData(
    12,
    "FLP-2025-012",
    "15/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Approved,
    "15/02/2025"
  ),
  createData(
    13,
    "FLP-2025-013",
    "15/02/2025",
    "Land Development for Agriculture",
    ApplicationStatus.Rejected,
    "15/02/2025"
  ),
];
